import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

interface TittleMangerProps {
  title?: string;
}

const TittleManger: React.FC<TittleMangerProps> = ({ title }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  return <></>;
};

export default observer(TittleManger);
